import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {ApiClientService} from '../../services/api-client.service';

@Component({
    selector: 'service-request-filter',
    templateUrl: './service-request-filter.component.html',
    styleUrls: ['./service-request-filter.component.scss']
})
export class ServiceRequestFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('openCheckbox')       open:       ElementRef;
    @ViewChild('inProgressCheckbox') inProgress: ElementRef;
    @ViewChild('onHoldCheckbox')     onHold:     ElementRef;
    @ViewChild('closedCheckbox')     closed:     ElementRef;
    @ViewChild('cancelledCheckbox')  cancelled:  ElementRef;
    @ViewChild('archivedCheckbox')   archived:   ElementRef;

    @ViewChild('urgentCheckbox')     urgent:     ElementRef;
    @ViewChild('highCheckbox')       high:       ElementRef;
    @ViewChild('mediumCheckbox')     medium:     ElementRef;
    @ViewChild('lowCheckbox')        low:        ElementRef;

    constructor(
        public api: ApiClientService,
        private urlService: UrlService
    ) {}

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(() => {
            const status = this.urlService.queryParams['status'];
            if (status) {
                this.open.nativeElement.checked = status.indexOf('open') !== -1;
                this.inProgress.nativeElement.checked = status.indexOf('in_progress') !== -1;
                this.onHold.nativeElement.checked = status.indexOf('on_hold') !== -1;
                this.closed.nativeElement.checked = status.indexOf('closed') !== -1;
                this.cancelled.nativeElement.checked = status.indexOf('cancelled') !== -1;
                this.archived.nativeElement.checked = status.indexOf('archived') !== -1;
            } else {
                this.open.nativeElement.checked = false;
                this.inProgress.nativeElement.checked = false;
                this.onHold.nativeElement.checked = false;
                this.closed.nativeElement.checked = false;
                this.cancelled.nativeElement.checked = false;
                this.archived.nativeElement.checked = false;
            }

            const priority = this.urlService.queryParams['priority'];
            if (priority) {
                this.urgent.nativeElement.checked = priority.indexOf('urgent') !== -1;
                this.high.nativeElement.checked = priority.indexOf('high') !== -1;
                this.medium.nativeElement.checked = priority.indexOf('medium') !== -1;
                this.low.nativeElement.checked = priority.indexOf('low') !== -1;
            } else {
                this.urgent.nativeElement.checked = false;
                this.high.nativeElement.checked = false;
                this.medium.nativeElement.checked = false;
                this.low.nativeElement.checked = false;

            }
        });
    }

    changeFilter(filterName?: string) {
        const openValue = this.open.nativeElement.checked;
        const inProgressValue = this.inProgress.nativeElement.checked;
        const onHoldValue = this.onHold.nativeElement.checked;
        const closedValue = this.closed.nativeElement.checked;
        const cancelledValue = this.cancelled.nativeElement.checked;
        const archivedValue = this.archived.nativeElement.checked;

        const urgentValue = this.urgent.nativeElement.checked;
        const highValue = this.high.nativeElement.checked;
        const mediumValue = this.medium.nativeElement.checked;
        const lowValue = this.low.nativeElement.checked;

        if (!openValue && !inProgressValue && !onHoldValue && !closedValue && !cancelledValue && !archivedValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (openValue) status += 'open,';
            if (inProgressValue) status += 'in_progress,';
            if (onHoldValue) status += 'on_hold,';
            if (closedValue) status += 'closed,';
            if (cancelledValue) status += 'cancelled,';
            if (archivedValue) status += 'archived,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }

        if (!urgentValue && !highValue && !mediumValue && !lowValue) {
            this.urlService.queryParams['priority'] = null;
        } else {
            let priority = '';
            if (urgentValue) priority += 'urgent,';
            if (highValue) priority += 'high,';
            if (mediumValue) priority += 'medium,';
            if (lowValue) priority += 'low,';
            this.urlService.queryParams['priority'] = priority.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('service-request-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/service-request-filter/service-request-filter.component.ts